// import { Spin } from "antd";
// import React, { useEffect } from "react";
// import ReactApexChart from "react-apexcharts";

// const SplineChart = ({ title, data = [], from: _from, to: _to, isLoading = false, interval: _interval = 1 }) => {
//     const series = data;

//     return (
//         // <Spin spinning={isLoading}>
//         <>
//             <ReactApexChart
//                 options={{
//                     chart: {
//                         id: "area-datetime",
//                         height: 350,
//                         type: "area",
//                         zoom: {
//                             autoScaleYaxis: true,
//                             autoScaleXaxis: true,
//                         },
//                         animations: {
//                             enabled: false,
//                         },
//                     },

//                     dataLabels: {
//                         enabled: false,
//                     },
//                     stroke: {
//                         width: 1,
//                         curve: "straight",
//                     },
//                     xaxis: {
//                         type: "datetime",
//                         labels: {
//                             datetimeUTC: false,
//                         },
//                     },

//                     tooltip: {
//                         x: {
//                             format: "dd/MM/yy HH:mm",
//                         },
//                     },
//                     title: {
//                         text: title,
//                         align: "center",
//                     },
//                     markers: {
//                         size: 0,
//                         style: "hollow",
//                     },
//                 }}
//                 series={series}
//                 type="area"
//                 height={450}
//             />
//             {/* </Spin> */}
//         </>
//     );
// };

// export default SplineChart;

import { Spin } from 'antd';
import React from 'react';
import CanvasJSReact from '../../assets/canvasjs.react';
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

const SplineChart = ({
  title,
  data = [],
  from: _from,
  to: _to,
  isLoading = false,
  interval: _interval = 1,
  critical,
  warning,
  yAxis,
}) => {
  const stripLines = [];
  if (critical) {
    stripLines.push({
      value: critical,
      color: '#dc3545',
      labelFontColor: '#dc3545',
      label: 'Critical Level',
      thickness: 5,
    });
  }
  if (warning) {
    stripLines.push({
      value: warning,
      color: '#ffc107',
      labelFontColor: '#ffc107',
      label: 'Warning Level',
      thickness: 5,
    });
  }
  return (
    <Spin spinning={isLoading}>
      <CanvasJSChart
        options={{
          zoomEnabled: true,
          theme: 'light2',
          animationEnabled: false,
          title: {
            text: title,
          },
          subtitles: [
            {
              text: title,
            },
          ],
          axisY: {
            includeZero: false,
            stripLines: [...stripLines],
            ...yAxis,
          },
          legend: {
            cursor: 'pointer',
            itemclick: function (e) {
              if (typeof e.dataSeries.visible === 'undefined' || e.dataSeries.visible) {
                e.dataSeries.visible = false;
              } else {
                e.dataSeries.visible = true;
              }
              e.chart.render();
            },
          },

          toolTip: {
            shared: true,
          },
          // colorSet: "greenShades",
          data: [
            ...data?.map((d) => ({
              type: 'splineArea',
              name: d.name,
              xValueFormatString: 'MMM YYYY, hh:mm TT',
              // color: "rgba(54,158,173,.7)",
              // yValueFormatString: "custom-format",
              showInLegend: true,
              dataPoints: d.data.map((t) => ({ x: new Date(t.x), y: t.y })),
            })),
          ],
        }}
      />
    </Spin>
  );
};

export default SplineChart;
